module.exports = __webpack_public_path__ + "img/IT0000106355634.7dac8dba.png";